var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaylistButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.590576,
    y: 0.392578,
    width: 43.9825,
    height: 44.1872,
    rx: 12,
    fill: "#C4C4C4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.22948 9.24838C8.22948 8.15092 9.38581 7.45226 10.294 8.00099L21.1735 14.5745C22.068 15.1149 22.0508 16.4642 21.1425 17.013L10.263 23.5864C9.35462 24.1353 8.22948 23.4762 8.22948 22.3953L8.22948 9.24838Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.57153 34.2136C7.57153 33.4457 8.19114 32.8232 8.95547 32.8232L35.9421 32.8232C36.7065 32.8232 37.3261 33.4457 37.3261 34.2136C37.3261 34.9815 36.7065 35.604 35.9421 35.604L8.95547 35.604C8.19114 35.604 7.57153 34.9815 7.57153 34.2136Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.259 25.8708C17.259 25.103 17.8786 24.4805 18.643 24.4805L35.9421 24.4805C36.7064 24.4805 37.3261 25.103 37.3261 25.8708C37.3261 26.6387 36.7064 27.2612 35.9421 27.2612L18.643 27.2612C17.8786 27.2612 17.259 26.6387 17.259 25.8708Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9465 17.529C26.9465 16.7612 27.5661 16.1387 28.3305 16.1387L35.9421 16.1387C36.7064 16.1387 37.326 16.7612 37.326 17.529C37.326 18.2969 36.7064 18.9194 35.9421 18.9194L28.3305 18.9194C27.5661 18.9194 26.9465 18.2969 26.9465 17.529Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylistButton);
export default __webpack_public_path__ + "static/media/playlist-button.6831a15eb3289f953a45710c605b2e7c.svg";
export { ForwardRef as ReactComponent };